import {Env} from "./environment";

const titleEnv = Env.getEnv("REACT_APP_TITLE");
export const TraderDocumentTitle = titleEnv ? titleEnv : "EP3 Trader";
export const INTEREST_RATE_SWAP = "Interest Rate Swap";
export const DEFAULT = "Default";
export const FORWAWRD_RATE_AGREEMENT = "Forward Rate Agreement Swap";
export const DEFAULT_PAGE_SIZE = 1024;

